/**
 * Highlights matching query text within a suggestion string.
 *
 * Splits the input text by the query and wraps matching parts in <strong> tags for emphasis.
 * Useful for autocomplete or search suggestion UIs.
 *
 * @param text - The full suggestion string.
 * @param query - The search query to highlight.
 * @returns React.ReactNode with highlighted matches.
 */
export const suggestionHighlightText = (text: string, query: string): React.ReactNode => {
  const parts = text.split(new RegExp(`(${query})`, 'gi'))
  return (
    <span>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <strong key={i}>{part}</strong>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </span>
  )
}
